import styled from 'styled-components'
import { AiImageGenerateOption } from '../styled'
import { CharacterCountIndicator } from 'common-components'

export const AiImageGenerationPrompt = styled(AiImageGenerateOption)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const CharacterCountIndicatorWrapper = styled(CharacterCountIndicator)`
  margin-top: 0px;
`
